import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Titlespan2, Title } from '../../components/title/index';
import Image from '../../components/image/index';
import Skills_img from '../../assets/images/skills/skills-img.png';
import Progressbar from './progressbar';
import './skills.scss';
import "../../assets/scss/variable.scss";


function Skills() {
    return (
        <section className="skills-wrapper" id="skills">
            <Container>
                <Row>
                    <Col md={6} sm={0}>
                        <div className="skills-image">
                            {/*<Image Path={Skills_img} Class="logo-img" />*/}
                        </div>
                    </Col>
                    <Col md={6} sm={12}>
                        <div className="skills-content-block main-title-wrapper">
                            <Titlespan2
                                Class="sitemain-subtitle"
                                Name="Our Approach"
                                Label=""
                            />
                            <Subtitle
                                Class="site-subtitle2"
                                Name="It's always about you"
                            />

                            <Description
                                Class="skills-dec"
                                Name="Your business is our business. We believe in making your dreams and goals a reality and our experts know just how to do that. We’re prepared to help you at any level, from impartial advice or practical assistance to help you make the most of every opportunity. Our approach is unique in the way we implement our ethos"
                            />
                            <div className="progress-outer-block">
                                <Title
                                    Class="progress-title"
                                    Name="Our Ethos"
                                />
                                <div className="progressbar-wrapper-block">
                                    <div className="progressbar-block">
                                        <ul>
                                            <li>- Listen with an intent to understand, not question.</li>
                                            <li>- Communicate regularly and in the right way to make it collaborative.</li>
                                            <li>- Consistently deliver results using the right people for the right challenge.</li>
                                            <li>- Empathize with a client’s objective/situation and localise</li>
                                            <li>- Always think of the client’s needs as your own needs.</li>
                                            <li>- Remain objective and not let ego dictate next steps.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Skills;
